var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"login-layout"},[_c('div',{staticClass:"login-content"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/images/logo.png"),"alt":""}})]),_c('router-view')],1)]),_c('div',{staticClass:"login-images"},[_c('div',{staticClass:"images-box"},[_c('i-image')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }